// extracted by mini-css-extract-plugin
export default {"siteLogo":"site-logo_siteLogo__76rcf"};